export const MIN_HOURS = 8;
export const MAX_HOURS = 17;

export const EMPLOYEE_SELECTED_MESSAGE_INTERVAL = 10 * 60 * 1000;
export const CALENDAR_FILTERS_LOCAL_STORAGE = 'ltb-calendar-filters';
